import React from 'react';
import { PastSpeaker } from './PastSpeaker';

const pastSpeakers = [
  {
    name: "Victoire de Margerie",
    role: "Présidente de Rondol Industrie",
    description: "Victoire de Margerie est une figure emblématique dans le domaine des matériaux et de l'industrie. Elle est présidente de Rondol Industrie et a également exercé des responsabilités dans de grandes entreprises internationales. Sa carrière s'est orientée vers le conseil stratégique, avec une expertise reconnue dans les secteurs de l'innovation et des nouveaux matériaux.",
    imageUrl: "https://www.grantthornton.fr/globalassets/1.-member-firms/france/images/insight-bannieres/2021/victoire-de-margerie_promo.jpg"
  },
  {
    name: "Émile Servan-Schreiber",
    role: "Fondateur de Hypermind",
    description: "Psychologue cognitif et entrepreneur, Émile Servan-Schreiber est un pionnier des marchés prédictifs et de l'intelligence collective. Fondateur de Hypermind, il explore comment les groupes peuvent anticiper des résultats mieux que les experts grâce à l'analyse de données et aux mécanismes prédictifs. Il est également auteur et conférencier sur les thèmes de l'innovation et de la psychologie décisionnelle.",
    imageUrl: "https://i.f1g.fr/media/figaro/orig/2016/01/11/XVMcf223322-b855-11e5-82b1-c852775923f2.jpg"
  },
  {
    name: "Diana Filippova",
    role: "Essayiste et Entrepreneur",
    description: "Diana Filippova est essayiste, entrepreneur et activiste. Diplômée de HEC Paris et Sciences Po, elle a cofondé OuiShare, un think tank promouvant une économie collaborative, et dirige Stroïka, un cabinet de conseil en communication. Ses publications, notamment Technopouvoir, questionnent les relations entre technologie, politique et société.",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/a/aa/%C3%89claireurs_de_futurs_-_Diana_Filippova_%2815536034785%29_%28cropped%29.jpg"
  },
  {
    name: "Philippe Varin",
    role: "Ancien président de PSA Peugeot Citroën",
    description: "Ancien président de PSA Peugeot Citroën, Philippe Varin a marqué l'industrie automobile par son engagement pour une transition énergétique responsable. Il a également dirigé des entreprises dans les secteurs de la métallurgie et de l'énergie, et est membre actif de divers conseils d'administration, plaidant pour une industrie européenne compétitive.",
    imageUrl: "https://www.lemoci.com/wp-content/uploads/2021/10/Varin-Suez.jpg"
  },
  {
    name: "Charlélie Couture",
    role: "Artiste pluridisciplinaire",
    description: "Charlélie Couture est un artiste pluridisciplinaire : musicien, peintre et photographe. Né à Nancy, il s'est imposé comme une voix originale de la chanson française. Sa musique mêle poésie et influences rock, tandis que ses œuvres visuelles explorent la complexité de l'expérience humaine.",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/a/ab/CharlElie_Couture_en_concert_%C3%A0_Montbard_le_30_juin_2018..jpg"
  },
  {
    name: "Aurélie Jean",
    role: "Docteure en sciences et experte en IA",
    description: "Docteure en sciences et experte en intelligence artificielle, Aurélie Jean est spécialisée dans la modélisation numérique. Elle est également essayiste et vulgarisatrice scientifique, partageant ses connaissances sur les biais algorithmiques et l'impact des technologies sur la société. Elle intervient dans de grandes institutions et médias.",
    imageUrl: "https://www.radiofrance.fr/s3/cruiser-production/2023/08/7581c65d-c47b-434f-a560-a2811c52aa5e/1200x680_sc_000-1es6cv.jpg"
  },
  {
    name: "Gabrielle Halpern",
    role: "Philosophe et autrice",
    description: "Philosophe et autrice, Gabrielle Halpern défend l'hybridation des savoirs comme clé pour répondre aux défis contemporains. Ses travaux abordent la résilience organisationnelle et les transformations sociétales, explorant le croisement entre philosophie, économie et innovation.",
    imageUrl: "https://www.babelio.com/users/AVT_Gabrielle-Halpern_2905.jpg"
  },
  {
    name: "Jean-Pierre Farandou",
    role: "Président de la SNCF",
    description: "Président de la SNCF depuis 2019, Jean-Pierre Farandou a bâti sa carrière au sein de l'entreprise ferroviaire. Il est reconnu pour sa gestion de projets d'envergure et son souci de concilier innovation et service public dans le domaine des transports.",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/SNCF_Jean-Pierre_Farandou_%28cropped%29.jpg/1200px-SNCF_Jean-Pierre_Farandou_%28cropped%29.jpg"
  },
  {
    name: "François Bouchard",
    role: "Haut fonctionnaire et ingénieur",
    description: "Haut fonctionnaire et ingénieur, François Bouchard est engagé dans les infrastructures publiques et le développement territorial. Il a contribué à des projets d'envergure dans le domaine de la mobilité et de l'aménagement urbain.",
    imageUrl: "https://cdn-s-www.lalsace.fr/images/42A518EC-AABA-4EEA-A548-EC3747B01ACF/NW_raw/francois-bouchard-directeur-general-des-services-de-la-grande-region-photo-l-alsace-1455393556.jpg"
  },
  {
    name: "François Pélissier",
    role: "Président de la CCI Grand Nancy Métropole",
    description: "Président de la Chambre de commerce et d'industrie Grand Nancy Métropole, François Pélissier est un entrepreneur dynamique et un défenseur du développement économique local. Il s'emploie à renforcer les liens entre entreprises et collectivités.",
    imageUrl: "https://www.lagazettefrance.fr/thumbs/1368%C3%971026/wp-content/uploads/2020/10/P-09-TL-1988-PHOTO-PELISSIERFRANCOIS.jpg"
  },
  {
    name: "Marie-Claire Villeval",
    role: "Économiste et directrice de recherche CNRS",
    description: "Économiste spécialisée dans la théorie des jeux et l'économie comportementale, Marie-Claire Villeval est directrice de recherche au CNRS. Ses travaux portent sur les interactions entre incitations économiques et comportements humains, notamment dans les contextes organisationnels.",
    imageUrl: "https://upload.wikimedia.org/wikipedia/commons/e/ec/Marie_Claire_Villeval.jpg"
  },
  {
    name: "Nicolas Bouzou",
    role: "Économiste et essayiste",
    description: "Nicolas Bouzou est un économiste et essayiste français. Diplômé de l'université Paris-Dauphine et de Sciences Po Paris, il a fondé en 2006 le cabinet de conseil Asterès, spécialisé en analyses économiques. Auteur de nombreux ouvrages, il intervient régulièrement dans les médias pour commenter l'actualité économique et sociale.",
    imageUrl: "https://www.lenouveleconomiste.fr/wp-content/uploads/2024/02/nicolas-bouzou.jpg"
  },
  {
    name: "Pr Nguyen Tran",
    role: "Chercheur et médecin",
    description: "Chercheur et médecin, le professeur Nguyen Tran est une référence en médecine interne et en maladies infectieuses. Ses contributions académiques et cliniques ont marqué le domaine médical, notamment dans le traitement des maladies complexes.",
    imageUrl: "https://cdn-s-www.estrepublicain.fr/images/AF8CEF8E-71CE-49A5-AD1C-82722671DF40/NW_raw/le-professeur-nguyen-tran-est-directeur-operationnel-de-l-ecole-de-chirurgie-de-nancy-photo-er-cedric-jacquot-1641486116.jpg"
  },
  {
    name: "Bruno Cohen",
    role: "Expert en stratégie numérique",
    description: "Bruno Cohen est un expert en stratégie et transformation numérique. Il accompagne les entreprises dans leur adaptation aux défis technologiques et organisationnels contemporains, mettant en avant l'importance de l'innovation et de l'agilité.",
    imageUrl: "https://img.lemde.fr/2017/11/23/697/0/3456/3456/664/0/75/0/ba68e05_12524-14f2h9c.16g6.jpg"
  },
  {
    name: "François Laval",
    role: "Directeur du campus de Sciences Po Nancy",
    description: "Juriste et politologue français, spécialiste du droit constitutionnel français et de la politique européenne. Depuis 2004, il dirige le campus de Nancy de Sciences Po (Institut d'études politiques de Paris).",
    imageUrl: "https://cdn-s-www.estrepublicain.fr/images/654A9348-79EB-49BF-BDC2-CA1CB71B10A2/NW_raw/francois-laval-directeur-du-campus-de-sciences-po-nancy-on-se-rapproche-des-taux-de-participation-des-nouvelles-democraties-d-europe-centrale-et-orientale-photo-er-alexandre-marchi-1655137821.jpg"
  },
  {
    name: "Jacques Cinqualbre",
    role: "Fondateur de Hopi Medical",
    description: "Ancien chirurgien transplanteur au CHU de Strasbourg, il s'est engagé depuis près de 20 ans dans le développement de la télémédecine. Il a fondé l'entreprise Hopi Medical, qui conçoit des outils technologiques pour le diagnostic à distance.",
    imageUrl: "https://img.lamontagne.fr/9DQKPFsHnfXPaQE9J1ih99A-YBMSXsfS0DKgnQ6jGSA/fit/657/438/sm/0/bG9jYWw6Ly8vMDAvMDAvMDQvMzkvNzgvMjAwMDAwNDM5NzgzMw.jpg"
  },
  {
    name: "Denis Schaming",
    role: "Délégué régional de la Fondation du patrimoine",
    description: "Avec plus de 20 ans d'expérience dans des fonctions de direction générale dans les services culturels et patrimoniaux en Lorraine, il est délégué régional de la Fondation du patrimoine pour la Lorraine, œuvrant pour la valorisation du patrimoine régional.",
    imageUrl: "https://cdn-s-www.republicain-lorrain.fr/images/46B3DA62-B73C-44E3-9BF9-5146F6CDB765/NW_raw/denis-schaming-a-ete-charge-d-assurer-l-interim-a-la-direction-du-cabinet-de-francois-grosdidier-a-la-metropole-photo-rl-gilles-wirtz-1701859139.jpg"
  }
];

export const PastSpeakers = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center mb-4">
          Ils sont intervenus au Cercle Poincaré
        </h2>
        <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12">
          Découvrez les personnalités qui ont partagé leur expertise et leur vision lors de nos événements
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {pastSpeakers.map((speaker) => (
            <PastSpeaker
              key={speaker.name}
              {...speaker}
            />
          ))}
        </div>
      </div>
    </section>
  );
};